import type { RouteRecordRaw } from 'vue-router';
import { Urls } from '@/config/Urls';

export const competitorsRoutes: RouteRecordRaw[] = [
  {
    path: Urls.COMPETITORS,
    name: 'competitors',
    component: () => import('./pages/CompetitorsList/Competitors.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: Urls.COMPETITORS_ADD,
    name: 'addCompetitor',
    component: () => import('./pages/CompetitorAdd/AddNewCompetitor.vue'),
    meta: { requiresAuth: true },
    props: { mode: 'ADD' },
  },
  {
    path: `${Urls.COMPETITORS_EDIT}/:id`,
    name: 'editCompetitor',
    component: () => import('./pages/CompetitorAdd/AddNewCompetitor.vue'),
    meta: { requiresAuth: true },
    props: { mode: 'EDIT' },
  },
  {
    path: `${Urls.COMPETITORS_BATTLES}/:id`,
    component: () => import('./pages/CompetitorDetail/Competitor.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'competitorBattles',
        component: () => import('./pages/CompetitorDetail/CompetitorBattlesContent.vue'),
      },
    ],
  }
];
